<template>
  <div class="wrapper">
    <div class="shop-container">
      <div class="nav">
        <router-link to="home">{{$t('home')}}</router-link>
        <span>></span>
        <span>{{this.type_name}}</span>
      </div>
      <div class="main"  v-loading="loading">
        <div class="l bgw">
          <!-- 帮助中心 -->
          <h6>{{this.type_name}}</h6>
          <div class="list-wrap" v-for="(item,index) in list" :key="index" @click="typeCLick(item)">
            <div class="classify">
              <img src="http://www.sanlida.cn/templates/pccommon/images/new/article_12.jpg" alt="">
              <h3 class="title">{{item.type_name}}</h3> 
            </div>
          </div>
        </div>
        <div class="r">
          <div class="bgw">
            <template v-if="showDetail">
              <div class="article-nav">
                <div v-for="(item,index) in detail.article_type" :key="index">
                  <div v-for="(father,key) in item.father" :key="key">
                    <span class="artlink">{{father.type_name}}</span> >
                    <a href="javascript:;" class="artlink" @click="getArticleList(item.id)">{{item.type_name}}</a>
                  </div>
                </div>
              </div>
              <div class="top-head">
                {{detail.title}}
                <div class="info">
                  <span>
                    {{detail.ctime}}
                  </span>
                </div>
              </div>
              <template>
                <div v-html="detail.content" style="line-height:20px;"></div>
              </template>
            </template>
            <template v-else>
			  <!-- 三级导航 -->
			  <div class="sub-nav">
				<ul>
				  <li 
					v-for="(item, index) in navItems"
					:key="index"
					:class="{ active: activeIndex === index }"
					@click="handleNavClick(index,item.id)"
				  >
					<a href="#" @click.prevent>{{ item.type_name }}</a>
				  </li>
				</ul>
			  </div>
				
              <ul class="art-list">
                <li v-for="(item,index) in articleList" :key="index">
                  <div class="media">
                    <div class="media-body">
                      <a href="javascript:;" @click="getArticleDetail(item.id)">
                        <h4>{{item.title}}</h4>
                      </a>
                      <div class="info">
                        <span>  {{newTime(item.ctime)}} </span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <Pagination :currentPage="page" :totalPage="totalPage" :limit="limit" @changePage="handOrderMore" v-if="totalPage>1"></Pagination>
            </template>
          </div>

          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination.vue'
export default {
  name: 'Center',
  components: { Pagination },
  inject: ['reload'],
  props: {},
  data() {
    return {
      list: [],
      page: 1,
      limit: 10,
      articleList: [],
      detail: {},
      totalPage: 0,
      showDetail: false,
      artClassId: '',
      hotList: [],
      artId: 0,
      where: {},
      loading: false,
      is_main: '',
	  type_name:'',
	  activeIndex: 0,
	  navItems: ''
    }
  },
  watch: {
    $route(v1) {

        console.log(v1)
      if(v1.query.type_id) {

      } else if(v1.query.search_name) {
        this.where.search_name = v1.query.search_name
        this.getArticleList('')
      } else {
        this.artId = ''
        this.artClassId = ''
        this.getArticleList('')
      }
    }
  },
  computed: {
    newTime() {
      return time => {
        let ctime = time.split(' ')
        return ctime[0]
      }
    }
  },
  methods: {
    handleNavClick(index,id) {
      this.activeIndex = index
      this.getArticleList(id)
    },
	  
    // 去帮助中心
    gocenter() {
      this.$router.push({
        path: '/down'
      })
    },
    typeCLick(val) {
      console.log(val)
      this.$router.replace({
        path: '/down',
        query: {
          type_id: val.id
        }
      })
      this.reload()
    },
    lookType(nav) {
      this.artClassId = nav.id
      this.getArticleList(nav.id)
    },
    handOrderMore(val) {  
      this.page = val
      this.getArticleList(this.artId)
    },
    //获取分类列表
    getArticleList(id) {

      this.loading = true
      let data = {
        page: this.page,
        limit: this.limit
      }
      if(id || this.artClassId) {
        data.type_id = id || this.artClassId
      }

      if(this.where.search_name) {
        data.where = JSON.stringify(this.where)
      }

      if(this.is_main) {
        data.token = this.$storage.get('userToken')
      }

      this.$api.articleList(data).then(res => {
        setTimeout(() =>{
          this.loading = false
        }, 500)
        if (res.status) {
		  if(data.type_id != 39){
			  if(res.data.article_type.length>0){
				  this.navItems = [{id: data.type_id, pid: 0, type_name: res.data.type_name+' > ', sort: 0}, ...res.data.article_type];
			  }
		  }
          this.articleList = res.data.list
          this.totalPage = Math.ceil(
            Number(res.data.count) / Number(this.limit)
          )
          this.showDetail = false
        }
      })
    },
    //获取文章详情
    getArticleDetail(id) {
			// 帮助中心返回保存分页信息
			this.$storage.set('helpindexpage', this.page)
      this.$router.push({
        path: '/downdetail',
        query: {
          article_id: id
        }
      })
      return
      let data = {
        article_id: id
      }
      this.$api.articleInfo(data).then(res => {
        if (res.status) {
          this.detail = res.data
          this.artClassId = res.data.article_type[0].id
          this.showDetail = true
          this.$router.replace({
            path: '/downdetail',
            query: {
              article_id: id
            }
          })
        } else {
          this.$msg(res.msg, 'error')
        }
      })
    },
    // 获取文章所有分类
    getArticleNav() {
      this.$api.articleTypeList().then(res => { 
        if (res.status) {
			let typelist = res.data.list.filter(item => item.id == 39);
			if(typelist[0].child.length>0){
				this.type_name = typelist[0].type_name;
				this.list = [{id: 39, pid: 0, type_name: "全部内容", sort: 0}, ...typelist[0].child];
			}
        }
      })
    },
    // 获取推荐
    getRecommend() {
      this.$api.articleRecommend().then(res => {
        if (res.status) {
          this.hotList = res.data.hot
        }
      })
    }
  },
  created() {},
  mounted() {
    if(this.$route.query) {
      this.is_main = this.$route.query.is_main
    }
    let query = this.$route.query
    this.artId = query.type_id
    if(query.search_name) {
      this.where.search_name = query.search_name
    }
		
		// 帮助中心返回更新分页信息
		if(this.$storage.get('helpdetail') && this.$storage.get('helpindexpage')) {
			this.page = this.$storage.get('helpindexpage')
			this.$storage.remove('helpdetail')
			this.$storage.remove('helpindexpage')
		}
    this.getArticleList(query.type_id)
    // this.getArticleList(query.type_id)


    
    if (query.type == 2) {
      this.artClassId = query.id
      this.getArticleList(query.id)
    } else if (query.article_id == undefined) {  
      // this.getArticleNav()
      // this.getRecommend()
    } else {
      this.getArticleDetail(query.article_id)
    }
    this.getArticleNav()
    this.getRecommend()
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.wrapper {
  .nav {
    @include line-height(40px);
    font-size: 12px;
    span {
      padding: 0 4px;
      font-size: #757575;
    }
    a:hover {
      color: #000;
    }
  }
  .main {
    display: flex;
    margin-bottom: 20px;
    flex-direction: row-reverse;
    .l {
      width: 234px;
      margin-left: 20px;
      // padding: 40px 0;
      h6 {
        width: 175px;
        color: #e7442f;
        border-bottom: 1px solid #f0f0f0;
        font-weight: normal;
        font-size: 18px;
        height: 45px;
        overflow: hidden;
        padding-left: 47px;
        line-height: 47px;
        background: #fff url('http://www.sanlida.cn/templates/pccommon/images/new/article_03.jpg') no-repeat 20px 16px;
        cursor: pointer;
      }
      .article {
        padding-left: 20px;
        img {
          height: 20px;
          vertical-align: bottom;
        }
        h2 {
          font-size: 17px;
          display: inline-block;
        }
      }

      .list-wrap {
        // margin-bottom: 20px;

        .classify {
          padding-left: 30px;
          cursor: pointer;
          img {
            width: 4px;
            vertical-align: middle;
            margin-right: 8px;
          }
          .title {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            color: #333;
          }
        }

        ul {
          padding-left: 20px;
          li {
            padding-left: 48px;
            height: 32px;
            line-height: 32px;
            color: #757575;
            cursor: pointer;
            &.active {
              color: $theme-color;
            }
            a:hover {
              color: $theme-color;
            }
            a.router-link-active {
              color: $theme-color;
            }
          }
        }
      }
      .xian {
        border-top: 1px solid #ccc;
        width: 190px;
        text-align: center;
        margin-left: 25px;
        margin-bottom: 20px;
      }
      .recommend {
        padding: 10px;
        .title {
          // font-size: 17px;
          // color: #555;
          img {
            height: 20px;
            vertical-align: bottom;
          }
          h2 {
            font-size: 17px;
            display: inline-block;
          }
        }
        .reList {
          margin-top: 10px;
          list-style: none;
          color: rgb(85, 85, 85);
          border: 1px solid #e4eaec;
          border-radius: 4px;
          cursor: pointer;
          .reItem {
            padding: 10px 10px 10px 15px;
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
            display: flex;
            .recommendTitle {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }
            img {
              width: 20px;
              vertical-align: middle;
            }
            span {
             
              line-height: 20px;
            }
            .title {
              white-space: nowrap;
              overflow:hidden; 
              text-overflow:ellipsis;
              // display:-webkit-box; 
              // -webkit-box-orient:vertical;
              // -webkit-line-clamp:2;
            }
          }
        }
      }
    }
    .r {
      flex: 1;
      .bgw {
        padding: 24px;
        min-height: 600px;
        
        .article-nav {
          height: 30px;
          line-height: 30px;
          border-bottom: 1px dashed $border;
          margin-bottom: 20px;
          a.artlink {
            &:hover {
              color: $theme-color;
            }
          }
        }
        .top-head {
          font-size: 24px;
          font-weight: 400;
          line-height: 40px;
          color: #757575;
          margin-bottom: 10px;
          border-bottom: 1px solid rgb(238, 238, 238);
          .info {
            font-size: 14px;
            color: #76838f;
            span {
              margin-right: 10px;
              img {
                width: 15px;
                vertical-align: middle;
              }
            }
          }
        }
      }
      .art-list {
        li {
          padding: 20px 10px;
          border-bottom: 1px solid rgb(238, 238, 238);
          a {
            display: block;
            // padding: 10px;
            cursor: pointer;
            &:hover {
              color: $theme-color;
            }
          }
          .media {
            .media-left {
              width: 100px;
              height: 100px;
              display: inline-block;
              padding-right: 20px;
              vertical-align: top;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .media-body {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              h4 {
                color: #333333;
                // margin-bottom: 20px;
                font-size: 16px;
              }
              .des {
                font-size: 14px;
                margin-bottom: 20px;
                color: #76838f;
                line-height: 20px;
              }
              .info {
                font-size: 14px;
                color: #76838f;
                span {
                  margin-right: 10px;
                  img {
                    width: 15px;
                    vertical-align: middle;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
.recommendCover {
  display: inline-block;
  width: 50px;
  height: 50px;
  vertical-align: top;
  img {
    width: 50px !important;
  }
}
.recommendTitle {
  display: inline-block;
  width: 131px;
  margin-left: 5px;
}
</style>

<style lang="scss">

.el-loading-parent--hidden {
  overflow: initial !important;
}

/* 三级导航 */
.sub-nav {
  margin-bottom: 20px;
}

.sub-nav ul {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  gap: 15px 30px; /* 行间距15px 列间距30px */
  list-style: none;
  padding-bottom: 2px; /* 为下划线预留空间 */
}

.sub-nav li {
  cursor: pointer;
  position: relative;
  flex-shrink: 0; /* 防止内容收缩 */
}

.sub-nav a {
  color: #666;
  text-decoration: none;
  padding: 10px 5px;
  display: block;
  font-size: 15px;
  white-space: nowrap; /* 防止文字换行 */
}

/* 悬停效果 */
.sub-nav li:not(.active):hover a {
  color: #007bff;
}

/* 激活状态 */
.sub-nav li.active a {
  color: #007bff;
  font-weight: 500;
}

.sub-nav li.active a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -5px; /* 调整下划线位置 */
  width: 100%;
  height: 2px;
  background: #007bff;
  animation: underline 0.3s ease;
}

@keyframes underline {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .sub-nav ul {
    gap: 10px 20px;
  }
  
  .sub-nav a {
    font-size: 14px;
    padding: 8px 4px;
  }
}
</style>
